import { Section } from '@sparknz/spark-pattern-library/types/components/Layers/ActionLayer/components/ProgressIndicator';

export type MinimalSection = Pick<Section, 'sectionId' | 'name'>;

export const buildProgressIndicatorSections = (sections: MinimalSection[]) =>
  sections.map(({ sectionId, name }) => ({
    sectionId,
    name,
    steps: [{ stepId: name }],
  }));
